export default "__VITE_ASSET__DuKLzsV9__"